<template>
	<div
		class="userMessage w-100"
		:style="{ height: isTablet ? windowHeight - 350 + 'px' : '' }"
	>
		<!-- DESKTOP -->
		<div v-if="!isTablet" class="d-flex w-100">
			<b-col class="content-1 pd-0">
				<div class="wrap-search">
					<div class="search-input">
						<b-form-input
							class="input-search"
							:placeholder="$t('userDashboard.messages.search')"
							v-model="keyword"
							@update="getListOfUser"
						></b-form-input>
						<MagnifyIcon class="icon-search" />
					</div>
				</div>
				<div class="wrap-user">
					<div style="text-align:center">
						<b-spinner
							variant="primary"
							label="Spinning"
							v-if="loading"
						></b-spinner>
					</div>
					<template v-for="(item, index) in userList">
						<div
							@click="handleChoseUser(item, index)"
							class="user-item"
							v-bind:class="{ active: selectedChatId == item.id }"
							:key="index"
						>
							<div class="avatar-user">
								<b-avatar
									:size="44"
									class="bg-transparent"
									:src="
										item.user_with && item.user_with.profile_image
											? item.user_with.profile_image
											: '/images/avatar.png'
									"
								></b-avatar>
							</div>
							<div class="pl-10">
								<div class="name-user">
									{{
										item.user_with && item.user_with.display_name
											? item.user_with.display_name
											: item.user_with.email
									}}
								</div>
								<div class="date-sent">
									{{
										item.last_massage_date
											| formatDate($router.currentRoute.params.lang)
									}}
								</div>
							</div>
							<span
								class="msg-unreal"
								v-if="item.unseen_messages != '0' && selectedChatId != item.id"
								>{{ item.unseen_messages }}</span
							>
						</div>
					</template>
					<infinite-loading @infinite="infiniteHandler" ref="infiniteLoading">
						<span slot="no-results"
							><b-alert show variant="light" v-if="!userList.length">{{
								$t('userDashboard.messages.emptyData')
							}}</b-alert></span
						>
						<span slot="no-more"></span>
					</infinite-loading>
				</div>
			</b-col>
			<b-col class="content-2 pd-0" >
				<div
					v-if="userList.length"
					class="wrap-scroll"
					:class="chatMessage.is_blocked ? 'bloced-chat' : ''"
				>
					
				
					<div
						v-if="(!chatMessage.with_support||chatMessage.blocked_by_me)||(chatMessage.blocked_by_me && !chatMessage.is_blocked)
						"
						class="block-div"
						:class="chatMessage.is_blocked ? 'bloced-selected' : ''"
					>
					<span>{{$t('userDashboard.messages.note')}}</span>
						<div class="block-button" @click="blockUser()">
							<IconBlock />
							<span style="margin-left:5px;margin-top:5px;">
								{{
									chatMessage.is_blocked
										? $t('userDashboard.messages.unblock')
										: $t('userDashboard.messages.block')
								}}
							</span>
						</div>
					</div>
					<div
						class="wrap-scroll-message"
						id="wrap-scroll-message"
						:style="{ height: windowHeight - 350 + 'px' }"
						v-if="userList.length || loadingMessage"
						draggable="true"  @dragover.prevent @drop.stop.prevent="drop" @dragover="allowDrop"
					>
						<infinite-loading
							@distance="2"
							direction="top"
							@infinite="infiniteHandlerMsgDetail"
							ref="infiniteHandlerMsgDetail"
						>
							<!-- <template v-slot:spinner="{ isFirstLoad }">
								<span v-if="!isFirstLoad">Loading more messages...</span>
							</template> -->
							<span slot="no-results"
								><b-alert
									show
									variant="light"
									v-if="!chatMessage.messages.length"
									>{{ $t('userDashboard.messages.emptyData') }}</b-alert
								></span
							>
							<span slot="no-more"></span>
						</infinite-loading>
						<template v-for="(message, key) in chatMessage.messages">
							<div class="wrap-message" :key="key" id="wrap-message">
								<div class="date-line" v-if="message.listing">
									<hr class="line-dash" />
									<div
										class="date"
										:class="
											chatMessage.is_blocked ? 'remove-white-background' : ''
										"
									>
										{{
											message.created_at
												| formatDate($router.currentRoute.params.lang, true)
										}}
										<ClockOutlineIcon />
										{{
											message.created_at
												| formatHour($router.currentRoute.params.lang)
										}}
									</div>
								</div>
								<div class="card-message" v-if="message.listing">
									<div
										class="bg-light-green"
										style="border-bottom-left-radius: 3px;"
									>
										<b-card
											no-body
											class="overflow-hidden card-item"
											style="max-width: 160px;"
										>
											<b-row no-gutters>
												<router-link
													id="listingDetail"
													style="width: 100%;"
													:to="
														$i18nRoute(
															{ name: 'listing-detail' },
															message.listing.id
														)
													"
												>
													<b-col md="12" class="p-0">
														<b-card-img
															:src="
																message.listing &&
																message.listing.url_feature_image
																	? message.listing.url_feature_image
																	: '/images/card1.png'
															"
															class="img-card"
														></b-card-img>
													</b-col>
													<b-col md="12" class="p-0">
														<b-card-body class="bg-light-green">
															<b-card-text class="name-product">
																{{
																	message.listing && message.listing.title
																		? message.listing.title
																		: '--'
																}}
															</b-card-text>
															<b-card-text class="price">
																{{
																	message.listing && message.listing.price
																		? message.listing.price.toLocaleString(
																				'th-TH'
																		  )
																		: '0'
																}}
																{{ $t('baht') }}
															</b-card-text>
														</b-card-body>
													</b-col>
												</router-link>
											</b-row>
										</b-card>
									</div>
									<div class="message-information">
										<div class="message" v-html="message.message"></div>
										<div class="contact-info">
											{{$t('Contact information ')}}
											<span class="id-user">{{
												`(ID: ${message.listing.id})`
											}}</span>
										</div>
										<div class="name-and-phone">
											<span
												class="name"
												v-if="
													message.user_from && message.user_from.display_name
												"
											>
												<router-link
													id="sellerDetail"
													class="sellar-div"
													:to="
														$i18nRoute(
															{ name: 'seller-detail' },
															message.user_from.id
														)
													"
												>
													<UserIcon style="color:gray" />
													{{
														message.user_from && message.user_from.display_name
															? message.user_from.display_name
															: message.user_from.email
													}}
												</router-link>
											</span>
											<span
												class="phone"
												v-if="message.user_from && message.user_from.telephone"
											>
												<a
													class="sellar-div"
													:href="
														`tel:${
															message.user_from && message.user_from.telephone
																? message.user_from.telephone
																: ''
														}`
													"
												>
													<PhoneIcon />
													{{
														message.user_from && message.user_from.telephone
															? message.user_from.telephone
															: ''
													}}
												</a>
											</span>
										</div>
										<div
											class="email"
											v-if="message.user_from && message.user_from.email"
										>
											<EmailIcon />
											<a
												:href="
													message.user_from && message.user_from.email
														? `mailto:${message.user_from.email}`
														: ''
												"
												>{{
													message.user_from && message.user_from.email
														? message.user_from.email
														: ''
												}}</a
											>
										</div>
									</div>
								</div>
								<div class="user-messsage-chat" v-if="!message.listing">
									<span
										class="message-date"
										:class="
											message.user_from.current_user == 1
												? 'receiver-message-date'
												: 'sender-message-date'
										"
									>
										<div v-if="message.seen">
											<IconCheck />
											<span style="margin-right:5px;">{{
												$t('userDashboard.messages.read')
											}}</span>
										</div>
										{{
											message.created_at
												| formatDate($router.currentRoute.params.lang, true)
										}}
										{{
											message.created_at
												| formatHour($router.currentRoute.params.lang)
										}}
									</span>
									<div
										:class="
											message.user_from.current_user == 1
												? 'sender-message'
												: 'receiver-message'
										"
										v-if="message.type != 'ATTACHMENTS'"
									>
										<span
											class=""
											v-if="message.type == 'MESSAGE'"
											v-html="message.message"
										>
										</span>
										<span
											class="location"
											style="cursor:pointer;"
											v-if="message.type == 'LOCATION'"
											@click="goToGoogleMap(message)"
											><IconMapPin
										/></span>
									</div>
									<template v-if="message.type == 'ATTACHMENTS'">
										<div
											class="message-attachment"
											:class="
												message.user_from.current_user == 1
													? 'sender-message-image'
													: 'receiver-message-image'
											"
											v-for="(media, index) in message.chat_message_media"
											:key="index"
										>
											<a
												class="file-a"
												:download="message.name"
												:href="media.url_media"
												target="_blank"
												v-if="getExtention(media) == 'other'"
											>
												<IconFile />
												<b-spinner
													variant="primary"
													label="Spinning"
													v-if="loadingFile"
												></b-spinner>
											</a>
											<a
												:href="media.url_media"
												target="_blank"
												v-if="getExtention(media) == 'image'"
											>
												<div
													class="message-image"
													:style="{
														backgroundImage: 'url(' + media.url_media + ')'
													}"
													:id="index"
													:class="
														message.user_from.current_user == 1
															? 'sender-message-image'
															: 'receiver-message-image'
													"
												></div>
											</a>
											<a
												:download="message.name"
												:href="media.url_media"
												target="_blank"
												v-if="getExtention(media) == 'video'"
											>
												<video
													width="320"
													height="240"
													controls
													id="media-video"
													autostart="false"
												>
													<source :src="media.url_media" />
													{{ $t('userDashboard.messages.videoNotSupported') }}
												</video>
											</a>
										</div>
									</template>
								</div>
							</div>
						</template>
					</div>
					<div
						v-if="typing"
						style="font-size: 12px; color: var(--projectPrimaryColor); padding: 10px;position: absolute;bottom: 56px;"
					>
						<b-spinner
							variant="success"
							type="grow"
							label="Spinning"
							small
							style="margin-right: 5px;"
						></b-spinner>
						<b-spinner
							variant="success"
							type="grow"
							label="Spinning"
							small
							style="margin-right: 5px;"
						></b-spinner>
						<b-spinner
							variant="success"
							type="grow"
							label="Spinning"
							small
							style="margin-right: 5px;"
						></b-spinner>
					</div>
					<div
						class="footer-message-div"
						v-if="chatMessage.messages.length"
						ref="footer-message-div"
					>
						<b-button
							class="selector"
							@click="showSmile = !showSmile"
							variant="link"
							:disabled="chatMessage.is_blocked"
						>
							<IconSmile />
						</b-button>
						<div
							v-if="showSmile"
							style="position: absolute; top: 126px; left: 0px;"
							v-closable="{
								exclude: ['footer-message-div'],
								handler: 'handleFocusOut'
							}"
						>
							<VEmojiPicker @select="selectEmoji" :emojiSize="32" />
						</div>
						<b-button
							v-if="false"
							class="selector"
							@click="getWindowLocation()"
							variant="link"
							:disabled="chatMessage.is_blocked"
						>
							<IconMapPin />
						</b-button>
						<input
							class="file-upload"
							type="file"
							ref="fileName"
							style="display: none"
							:accept="fileAccept"
							multiple
							@change="getFile"
							:disabled="chatMessage.is_blocked"
						/>
						<b-button
							class="selector"
							@click="$refs.fileName.click()"
							variant="link"
							:disabled="chatMessage.is_blocked"
						>
							<IconAttachment />
						</b-button>
						<textarea
							@keyup.enter.exact="enterFunction"
							v-debounce="typingFunctionTrue"
							:debounce-events="['keydown']"
							name=""
							v-model="text"
							class="form-control type_msg"
							placeholder="Type your message..."
							:disabled="chatMessage.is_blocked"
						></textarea>
						<b-button
							class="button-send"
							@click="sendMessage()"
							:disabled="chatMessage.is_blocked"
							:class="chatMessage.is_blocked ? 'disabled-button' : ''"
							>{{ $t('userDashboard.messages.send') }}
						</b-button>
					</div>
				</div>
				<div class="wrap-scroll no-message-display" v-if="!userList.length">
					<div class="wrap-scroll-message" id="wrap-scroll-message">
						<div class="wrap-message " id="wrap-message">
							{{ $t('userDashboard.messages.emptyData') }}
						</div>
					</div>
				</div>
			</b-col>
		</div>
		<!-- TABLET -->
		<div v-if="isTablet">
			<div v-if="!mobileChooseChatId">
				<b-col class="content-1 pr-0" style="border:none;">
					<div class="wrap-user">
						<template v-for="(item, index) in userList">
							<div
								@click="handleChoseUser(item, index)"
								class="user-item"
								:key="index"
							>
								<div class="avatar-user">
									<b-avatar
										:size="44"
										:src="
											item.user_with && item.user_with.profile_image
												? item.user_with.profile_image
												: '/images/avatar.png'
										"
									></b-avatar>
								</div>
								<div class="pl-10">
									<div class="name-user">
										{{
											item.user_with && item.user_with.display_name
												? item.user_with.display_name
												: item.user_with.email
										}}
									</div>
									<div class="date-sent">
										{{
											item.last_massage_date
												| formatDate($router.currentRoute.params.lang)
										}}
									</div>
								</div>
								<div
									class="notification-number"
									v-if="item.unseen_messages != '0' && selectedChatId != item.id"
								>
									{{ item.unseen_messages }}
								</div>
							</div>
						</template>
						<infinite-loading @infinite="infiniteHandler" ref="infiniteLoading">
							<span slot="no-results"
								><b-alert show variant="light" v-if="!userList.length">{{
									$t('userDashboard.messages.emptyData')
								}}</b-alert></span
							>
							<span slot="no-more"></span>
						</infinite-loading>
					</div>
				</b-col>
			</div>
			<span v-if="mobileChooseChatId && userList.length" style="font-size: 16px; display: flex; align-items: center; width: 100%; height: 50px; padding: 0 15px; border: 1px solid #e5e5e5;color: #444444; margin-bottom: 20px;">{{$t('userDashboard.messages.note')}}</span>
			<MessageListMobile
				:message-item="chatMessage"
				:infinite-handler-msg-detail="infiniteHandlerMsgDetail"
				:get-extention="getExtention"
				:go-to-google-map="goToGoogleMap"
				:windowHeight="windowHeight"
				ref="infiniteHandlerMsgDetail"
				v-if="mobileChooseChatId && userList.length"
			/>
			<div class="wrap-scroll no-message-display" v-if="!userList.length">
				<div class="wrap-scroll-message" id="wrap-scroll-message">
					<div class="wrap-message " id="wrap-message">
						{{ $t('userDashboard.messages.emptyData') }}
					</div>
				</div>
			</div>
			<div
				v-if="typing"
				style="font-size: 12px; color: var(--projectPrimaryColor); padding: 10px;position: absolute;bottom: 0;"
			>
				<b-spinner
					variant="primary"
					type="grow"
					label="Spinning"
					small
					style="margin-right: 5px;"
				></b-spinner>
				<b-spinner
					variant="primary"
					type="grow"
					label="Spinning"
					small
					style="margin-right: 5px;"
				></b-spinner>
				<b-spinner
					variant="primary"
					type="grow"
					label="Spinning"
					small
					style="margin-right: 5px;"
				></b-spinner>
			</div>
			<div class="footer-message-div" v-if="chatMessage.messages.length">
				<b-button
					v-if="false"
					class="selector"
					@click="getWindowLocation()"
					variant="link"
					:disabled="chatMessage.is_blocked"
				>
					<IconMapPin />
				</b-button>
				<input
					type="file"
					ref="fileName"
					class="file-upload"
					style="display: none"
					:accept="fileAccept"
					multiple
					@change="getFile"
					:disabled="chatMessage.is_blocked"
				/>
				<b-button
					class="selector"
					@click="$refs.fileName.click()"
					variant="link"
					:disabled="chatMessage.is_blocked"
				>
					<IconAttachment />
				</b-button>
				<textarea
					@keyup.enter.exact="enterFunction"
					v-debounce="typingFunctionTrue"
					:debounce-events="['keydown']"
					name=""
					v-model="text"
					class="form-control type_msg"
					placeholder="Type your message..."
					:disabled="chatMessage.is_blocked"
				></textarea>
				<b-button
					class="button-send"
					@click="sendMessage()"
					:disabled="chatMessage.is_blocked"
					:class="chatMessage.is_blocked ? 'disabled-button' : ''"
					>{{ $t('userDashboard.messages.send') }}
				</b-button>
			</div>

			<div
				v-if="
					mobileChooseChatId 
				"
				class="block-div"
				:class="chatMessage.is_blocked ? 'bloced-selected' : ''"
			>
				<div
					class="block-button"
					style="width: 100%; padding: 5px; margin-right: 10px;"
					@click="
						selectedChatId = null;
						mobileChooseChatId = false;
						chatMessage.messages = [];
						chatMessage.blocked_by_me = false;
						chatMessage.is_blocked = false;
					"
				>
					{{ $t('userDashboard.messages.backtolist') }}
				</div>
				<div class="block-button" @click="blockUser()"
				v-if="
					mobileChooseChatId &&
						((!chatMessage.with_support||chatMessage.blocked_by_me)||(chatMessage.blocked_by_me && !chatMessage.is_blocked))
				">
					<IconBlock />
					<span style="margin-left:5px;margin-top:5px;">
						{{
							chatMessage.is_blocked
								? $t('userDashboard.messages.unblock')
								: $t('userDashboard.messages.block')
						}}
					</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// Icons
import MagnifyIcon from 'vue-material-design-icons/Magnify.vue';
import EmailIcon from 'vue-material-design-icons/EmailOutline.vue';
import UserIcon from 'vue-material-design-icons/AccountOutline.vue';
import PhoneIcon from '@/components/icons/IconPhone/index';
import IconAttachment from '@/components/icons/IconAttachment/index';
import IconMapPin from '@/components/icons/IconMapPin/index';
import IconFile from '@/components/icons/IconFile/index';
import IconBlock from '@/components/icons/IconBlock/index';
import IconCheck from '@/components/icons/IconCheck/index';
import IconSmile from '@/components/icons/IconSmile/index';
import ClockOutlineIcon from 'vue-material-design-icons/ClockOutline.vue';

import moment from 'moment';
import $ from 'jquery';
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';

import InfiniteLoading from 'vue-infinite-loading';
import MessageListMobile from '@/components/messageListMobile';
import VEmojiPicker from 'v-emoji-picker';
import closable from '@/plugins/closable.js';

export default {
	components: {
		MagnifyIcon,
		EmailIcon,
		UserIcon,
		PhoneIcon,
		ClockOutlineIcon,
		MessageListMobile,
		InfiniteLoading,
		IconAttachment,
		IconMapPin,
		IconFile,
		IconBlock,
		IconCheck,
		VEmojiPicker,
		IconSmile
	},
	props: {
		choseUser: {
			type: String,
			default: null
		}
	},
	data() {
		return {
			typing: false,
			windowHeight: null,
			showSmile: false,
			loading: false,
			loadingMessage: false,
			loadingFile: false,
			mobileChooseChatId: null,
			text: null,
			selectedChatId: null,
			messageCurView: [],
			userList: [],
			keyword: null,
			selectedType: 'MESSAGE',
			mediaList: [],
			config: {
				take: 10,
				page: 1,
				limit: 10
			},
			configMsgDetail: {
				take: 10,
				page: 1,
				limit: 10
			},
			chatMessage: {
				messages: [],
				is_blocked: false,
				blocked_by_me: false,
				with_support: false,
			},
			fileAccept: ['audio/*', 'video/*', 'image/*', 'application/pdf'],
			isAdmin: this.$route.name == 'AdminMessage' ? true : false
		};
	},
	filters: {
		formatDate(value, lang, hide = false) {
			if (!value) return;
			let todayText = 'today';
			if (lang == 'en') todayText = 'today';
			let now = moment(new Date());
			let newVal = moment(value);
			if (now.isSame(newVal, 'day')) {
				if (!hide) return todayText;
				return;
			}
			return moment(value)
				.locale('th')
				.format('DD MMM YYYY');
		},
		formatHour(value, lang) {
			if (!value) return;
			return moment(value)
				.locale('th')
				.format('HH:mm a');
		}
	},

	watch: {
		selectedChatId(val) {
			if (val) {
				this.updateScroll();
			}
		},
		'$refs.file': function(val) {},
		isTablet(val) {
			if (val) {
				this.reset();
			}
		},
		'$root.socket'(val){
			console.log("val",val)
			this.initSocketForMessage();
		}
	},
	methods: {
		// ...mapActions('UserDashboardController', ['GET_DATA_USER_DASHBOARD']),
		...mapActions('ChatController', [
			'GET_CHAT_HISTORY_USER',
			'GET_CHAT',
			'BLOCK_USER',
			'SEND_CHAT_MESSAGE'
		]),
		...mapMutations("ChatController", ['SET_UNREAD_MESSAGE']),
		selectEmoji(emoji) {
			if (!this.text) {
				this.selectedType = 'MESSAGE';
				this.text = emoji.data;
				this.chatMessage.messages.push({
					message: emoji.data,
					type: 'MESSAGE',
					created_at: new Date(),
					seen: true,
					user_from: {
						id: 0,
						display_name: '',
						telephone: '',
						email: '',
						current_user: 1
					},
					listing: null,
					chat_message_media: []
				});
				this.postChat();
				this.updateScroll();
			} else {
				this.text = this.text + emoji.data;
			}

			this.showSmile = false;
		},

		getWindowLocation() {
			let _this = this;
			this.selectedType = 'LOCATION';
			if (window.navigator.geolocation) {
				// Geolocation available
				window.navigator.geolocation.getCurrentPosition(
					_this.successCallback,
					_this.failureCallback
				);
			} else {
				
			}
		},
		successCallback(ev) {
			
			this.senderCords = ev.coords;
			this.chatMessage.messages.push({
				message: `{ "lat": "${ev.coords.latitude}", "lng": "${ev.coords.longitude}" }`,
				type: 'LOCATION',
				created_at: new Date(),
				seen: true,
				user_from: {
					id: 0,
					display_name: '',
					telephone: '',
					email: '',
					current_user: 1
				},
				listing: null,
				chat_message_media: []
			});
			this.postChat();
			this.updateScroll();
		},
		failureCallback(err) {
			
			let message = '';
			if (err.message == 'User denied Geolocation') {
				message = this.$t('You have blocked the location in your browser');
			} else {
				message = this.$t('When you unshare your location, you cannot share your location in chat');
			}
			this.$bvModal
				.msgBoxOk(message, {
					title: this.$t('action required'),
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					okTitle: this.$t('cancel'),
					headerClass: 'p-2 border-bottom-0',
					footerClass: 'p-2 border-top-0',
					centered: true
				})
				.then(value => {})
				.catch(err => {
					// An error occurred
				});
		},
		goToGoogleMap(message) {
			let lat = JSON.parse(message.message.toString()).lat;
			let lng = JSON.parse(message.message.toString()).lng;
			window.open(
				`https://www.google.com/maps/place/${lat},${lng}/@${lat},${lng},13z`
			);
		},
		sendMessage() {
			this.selectedType = 'MESSAGE';
			if (this.text) {
				this.chatMessage.messages.push({
					message: this.text,
					type: 'MESSAGE',
					created_at: new Date(),
					seen: true,
					user_from: {
						id: 0,
						display_name: '',
						telephone: '',
						email: '',
						current_user: 1
					},
					listing: null,
					chat_message_media: []
				});
				this.postChat();
				this.updateScroll();
			}
		},
		getFile(ev) {
			let _this = this;
			let files = ev.target.files;
			this.mediaList = ev.target.files;
			this.selectedType = 'ATTACHMENTS';
			var URL = window.URL || window.webkitURL;
			let obj={
				message: { name: null },
				type: 'ATTACHMENTS',
				created_at: new Date(),
				seen: true,
				user_from: {
					id: 0,
					display_name: '',
					telephone: '',
					email: '',
					current_user: 1
				},
				listing: null,
				chat_message_media: []
			}
			if (files.length) {
				for (const [key, value] of Object.entries(files)) {
					var fr = new FileReader();
					obj.message.name=value.name;
					if (value.type.match(/video/g)) {
						obj.chat_message_media.push({ url_media: URL.createObjectURL(value), type: 'video' });
						this.loadingFile = true;
					} else if (value.type.match(/image/g)) {
						obj.chat_message_media.push({ url_media: URL.createObjectURL(value), type: 'image' });
					} else {
						obj.chat_message_media.push({ url_media: URL.createObjectURL(value) });
					}
					
					
					
					if(key==(files.length-1)){
						_this.chatMessage.messages.push(obj);
						_this.postChat();
						_this.updateScroll();
					}
				}
			}
		},
		updateScroll() {
			setTimeout(() => {
				$('#wrap-scroll-message')
					.stop()
					.animate(
						{
							scrollTop: $('#wrap-scroll-message').get(0).scrollHeight
						},
						10
					);
			}, 500);
		},
		postChat() {
			
			var formData = new FormData();
			formData.append('chat_id', this.selectedChatId);
			formData.append('type', this.selectedType);
			if (this.selectedType == 'ATTACHMENTS') {
				for (const [key, value] of Object.entries(this.mediaList)) {
					formData.append('message_media', value);
				}
				formData.append('message', this.text);
			}
			if (this.selectedType == 'LOCATION') {
				formData.append(
					'message',
					`{ "lat": "${this.senderCords.latitude}", "lng": "${this.senderCords.longitude}" }`
				);
				formData.append('message_media', []);
			}
			if (this.selectedType == 'MESSAGE') {
				formData.append('message', this.text);
				formData.append('message_media', []);
			}
			if (!this.chatMessage.is_blocked) {
				this.SEND_CHAT_MESSAGE({ formData: formData, admin: this.isAdmin })
					.then(data => {
						this.senderCords = null;
						this.text = null;
						this.mediaList = [];
						
						this.$refs.fileName.value = '';
						this.loadingFile = false;
					})
					.catch(err => {
						
						if (err.data.detail == 'CHAT_NOT_ALLOWED') {
							this.chatMessage.is_blocked = true;
							this.text = null;
							this.mediaList = [];
							this.chatMessage.messages.pop();
							this.$bvToast.toast(
								this.$t('userDashboard.messages.youAreBlocked'),
								{
									title: `Error`,
									variant: 'dangor',
									solid: true
								}
							);
						}
					});
			} else {
				this.$bvToast.toast(this.$t('userDashboard.messages.youAreBlocked'), {
					title: `Error`,
					variant: 'dangor',
					solid: true
				});
			}
		},
		handleChoseUser(user) {
			if (user.id != this.selectedChatId && this.mobileChooseChatId != user.id) {
				this.reset();
				this.selectedChatId = user.id;
				this.mobileChooseChatId = user.id;
			}
		},

		reset() {
			
			this.configMsgDetail = {
				take: 10,
				page: 1,
				limit: 10,
				pageCount: 0
			};
			this.chatMessage = {
				messages: [],
				blocked: false
			};
			this.senderCords = null;
			this.text = null;
			this.mediaList = [];
			if (this.$refs.infiniteHandlerMsgDetail) {
				this.$refs.infiniteHandlerMsgDetail.stateChanger.reset();
			}
		},

		getExtention(url) {
			let a = null;
			if (
				(url.url_media.match(/blob/g) &&
					url.type &&
					url.type.match(/image/g)) ||
				url.url_media.match(/jpg/g) ||
				url.url_media.match(/eps/g) ||
				url.url_media.match(/png/g) ||
				url.url_media.match(/gif/g) ||
				url.url_media.match(/bmp/g) ||
				url.url_media.match(/jpeg/g)
			) {
				a = 'image';
			} else if (
				(url.url_media.match(/blob/g) &&
					url.type &&
					url.type.match(/video/g)) ||
				url.url_media.match(/mp4/g) ||
				url.url_media.match(/3gp/g) ||
				url.url_media.match(/mkv/g) ||
				url.url_media.match(/ogg/g) ||
				url.url_media.match(/mov/g) ||
				url.url_media.match(/avi/g) ||
				url.url_media.match(/wmv/g) ||
				url.url_media.match(/mpg/g) ||
				url.url_media.match(/mpeg/g) ||
				url.url_media.match(/3g2/g) ||
				url.url_media.match(/flv /g) ||
				url.url_media.match(/webm/g)
			) {
				a = 'video';
			} else {
				a = 'other';
			}
			return a;
		},

		getListUserHistory() {
			return this.GET_CHAT_HISTORY_USER({
				query: this.keyword,
				take: this.config.take,
				page: this.config.page,
				admin: this.isAdmin
			});
		},
		async infiniteHandler($state) {
			this.getListUserHistory().then(response => {
				if (!response.data.data) {
					return $state.complete();
				}

				this.config = response.data.meta;
				if (response.data.data.length) {
					if (this.config.page == 1) {
						this.userList = response.data.data;
					} else {
						response.data.data.forEach(elm => {
							this.userList.push(elm);
						});
					}
					if (!this.isTablet && !this.mobileChooseChatId) {
						this.selectedChatId = response.data.data[0].id;
						this.mobileChooseChatId = response.data.data[0].id;
						this.handleChoseUser(response.data.data[0]);
					}
				}
				if (this.config.page < this.config.pageCount) {
					this.config.page += 1;
					$state.loaded();
				} else $state.complete();
			});
		},
		getListOfUser() {
			let _this = this;
			this.loading = true;
			setTimeout(() => {
				this.getListUserHistory().then(response => {
					this.userList = response.data.data;
					_this.loading = false;
					this.$forceUpdate();
				});
			}, 1000);
		},
		infiniteHandlerMsgDetail($state, page) {
			
			this.loadingMessage = true;
			this.getChatMessage().then(response => {
				if (!response.data.data) {
					return $state.complete();
				}
				this.configMsgDetail = response.data.meta;
				this.chatMessage.is_blocked = response.data.data.is_blocked;
				this.chatMessage.blocked_by_me = response.data.data.blocked_by_me;
				this.chatMessage.with_support = response.data.data.with_support;
				response.data.data.messages.forEach(elm => {
					this.chatMessage.messages.unshift(elm);
					this.$forceUpdate();
				});
				this.loadingMessage = false;
				if (this.configMsgDetail.page < this.configMsgDetail.pageCount) {
					this.configMsgDetail.page += 1;
					$state.loaded();
					// this.updateScroll();
				} else $state.complete();
			});
		},
		getChatMessage() {
			return this.GET_CHAT({
				chatId: this.selectedChatId,
				take: this.configMsgDetail.take,
				page: this.configMsgDetail.page,
				admin: this.isAdmin
			});
		},
		blockUser() {
			this.BLOCK_USER({ chat_id: this.selectedChatId, admin: this.isAdmin })
				.then(({ data }) => {
					this.chatMessage.is_blocked = data.data.isBlocked;
					this.chatMessage.blocked_by_me = data.data.isBlocked;
					this.$forceUpdate();
					this.$bvToast.toast(
						data.data.is_blocked
							? this.$t('userDashboard.messages.userBlocked')
							: this.$t('userDashboard.messages.userUnBlocked'),
						{
							title: `Success`,
							variant: 'success',
							solid: true
						}
					);
				})
				.catch(err => {});
		},

		handleFocusOut() {
			
			this.showSmile = false;
		},
		enterFunction(ev) {
			
			if (ev.key == 'Enter') {
				this.sendMessage();
			}
		},
		typingFunctionTrue(ev) {
			let _this = this;
			
			this.$root.socket.emit('chat-typing', {
				chat_id: _this.selectedChatId,
				typing: true
			});
			setTimeout(() => {
				
				this.$root.socket.emit('chat-typing', {
					chat_id: _this.selectedChatId,
					typing: false
				});
			}, 1000);
		},
		onResize() {
			this.windowHeight = parseInt(document.documentElement.clientHeight);
			
			this.$forceUpdate();
		},
		drop(ev){
			
			 const files = event.dataTransfer.files;
			this.getFile({target:{files:files}});
			// ev.preventDefault();
		},
		allowDrop(ev){
			 ev.preventDefault();
		},
		socketIoDataRec(data){
			let _this =this;
			
			if (parseInt(data.chat_id) == _this.selectedChatId && JSON.parse(localStorage.getItem('user_profile')).id!=data.user_admin_id_from) {
				_this.chatMessage.messages.push({
					message: data.message,
					type: data.type,
					created_at: data.created_at,
					seen: true,
					user_from: {
						id: data.user_id_from,
						display_name: '',
						telephone: '',
						email: '',
						current_user: data.admin?1:0
					},
					listing: data.listing,
					chat_message_media: data.chat_message_media
				});
				_this.updateScroll();
				if(this.$router.history.current.name== "AdminMessage"){
					
				}
			} else {
				_this.userList.sort(function(a, b) {
					return a.id == data.chat_id ? -1 : b.id == data.chat_id ? 1 : 0;
				});
				let index=_this.userList.find(elment=>elment.id ==data.chat_id);
				
				if (index) {
					_this.userList[0].unseen_messages =
						parseInt(_this.userList[0].unseen_messages) + 1;
				} else {
					_this.getListOfUser();
				}
				_this.$forceUpdate();
				
			}
		},
		initSocketForMessage(){
			let _this = this;
			if(this.$root.socket){
				this.$root.socket.on('chat-message', function(data) {
					
					_this.socketIoDataRec(data)
				});
				this.$root.socket.on('chat-message-admin', function(data) {
					
					_this.socketIoDataRec(data)
				});
				this.$root.socket.on('chat-typing', function(data) {
					if (parseInt(data.chat_id) == _this.selectedChatId) {
						_this.typing = data.typing;
					}
				});
				this.$nextTick(() => {
					window.addEventListener('resize', this.onResize);
					this.onResize();
				});
			}else{
				this.$root.initSocket();
			}
		}
	},
	created() {
		this.onResize();
		this.SET_UNREAD_MESSAGE(0);
		this.$forceUpdate();

	},
	computed: {
		...mapGetters('UserController', ['isTablet']),
		
	},
	mounted() {
		this.initSocketForMessage();
		this.$nextTick(() => {
			window.addEventListener('resize', this.onResize);
			this.onResize();
		});
		return false;
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onResize);
	}
};
</script>
<style lang="scss">
@import 'message.scss';
</style>
